import { render } from "./LandingView.vue?vue&type=template&id=a6e8910e&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=a6e8910e&scoped=true&lang=css"

import exportComponent from "/home/wsl-ubuntu/work-repos/ats-201-build-a-planet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e8910e"]])

export default __exports__